import React from "react"
import EditButton from "./EditButton";
import { useGlobal } from "./Reducer";
import Api, { BUILD, eSOT } from "./Api";
export default (props)=>{

    const article=props.article||{};
    const [gs,ga]=useGlobal();

    return (<div style={{ marginTop:BUILD==eSOT?20:6}} className="col-md-12 col-lg">
        <div className="changeable newsset" ref_tag="news_setter"
    style={{textAlign:"right",position:"absolute",right:5,zIndex:5}}
    >                  <div className="globaleditbtn  hvr-shrink" data-toggle="tooltip" data-placement="right" title="" data-original-title="Edit News Articles"><EditButton onClick={()=>{
        props.setShowEditor(true);
    }}/></div></div>
        
        
        <div className="whitebg boxed  recent_news"><a href="#" onClick={(e)=>{
             e.preventDefault();
             props.expandView(props.article);
        }} className="recent_news_thumb"  ><img src={article.image} className="recent_newsimg" alt={article.title}/></a><div className="news_content faded_article padded"><div style={{marginBottom:20}} className="recent_news_intro lvl1 graytext">{article.title}</div><div style={{marginTop:-25,marginBottom:-10}}   className="news_summary"><span style={{fontSize:10,fontStyle:"italic"}}></span>{article.byline}</div><div className="news_summary" dangerouslySetInnerHTML={{__html:article.intro}}></div></div><div className="text-center"><a href="#"
        
            onClick={(e)=>{
                e.preventDefault();
                props.expandView(props.article);
                Api.recordAnalytics(gs.appData.id,"ARTICLE_OPEN",props.article.title,props.article.id);

            }}
        
        className="recent_news_learnmore dpl_btn"  >Read more</a></div></div></div>);
};